module.exports = "## Paper\nA [Paper](https://www.google.com/design/spec/layout/principles.html#principles-how-paper-works)\nelement is a basic container that can give depth to the page.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Paper/README.md
 ** module id = 1025
 ** module chunks = 0
 **/